var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.776381 1.17234C0.775748 1.06252 0.796735 0.953646 0.83814 0.851973C0.879545 0.7503 0.940555 0.657825 1.01767 0.57985C1.09501 0.501634 1.18703 0.439553 1.28842 0.397186C1.38981 0.35482 1.49856 0.333008 1.6084 0.333008C1.71823 0.333008 1.82698 0.35482 1.92837 0.397186C2.02976 0.439553 2.12179 0.501634 2.19913 0.57985L5.00105 3.34203L7.80303 0.575673C7.95892 0.420247 8.16979 0.333008 8.3896 0.333008C8.60941 0.333008 8.82028 0.420247 8.97617 0.575673C9.05415 0.65325 9.11605 0.745546 9.15829 0.847236C9.20053 0.948927 9.22228 1.058 9.22228 1.16816C9.22228 1.27833 9.20053 1.3874 9.15829 1.48909C9.11605 1.59078 9.05415 1.68308 8.97617 1.76065L5.58347 5.09446C5.42794 5.24736 5.21884 5.33301 5.00105 5.33301C4.78327 5.33301 4.57417 5.24736 4.41864 5.09446L1.04263 1.75649C0.961977 1.68158 0.896925 1.5914 0.851226 1.49113C0.805528 1.39087 0.78009 1.28252 0.776381 1.17234Z",
    fill: "#06203A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.22e6d4ee3d1d94ac275519ab602eb554.svg";
export { ForwardRef as ReactComponent };